<script lang="ts" setup>
import MvButton from '@/components/common/button/MvButton.vue';
import { INFO_EMAIL } from '@/config/constants';

const emits = defineEmits(['confirm'])

</script>

<template>
<div class="modal-common">
    <div class="title-row mb-24">
      {{ $t('modal.qtnrModify.title') }}
    </div>
    <div class="desc-row mb-24">
      {{ $t('modal.qtnrModify.desc', { email: INFO_EMAIL }) }}
    </div>
    <div class="button-row">
      <mv-button
          type="rec-primary"
          :text="$t('common.confirm')"
          @click="$emit('confirm')"
      />
    </div>
  </div>
</template>
